import { childActionTypes } from '../../settings/types'

export const clearState = () => ({
    type : childActionTypes.clearState,
});

export const resetCombos = data => ({
    type : childActionTypes.resetCombos,
    payload : data
});

export const setItem = data => ({
    type : childActionTypes.childObject,
    payload : data
});

export const setSubForm = ( editMode = false, disableInputs = false, saveSuccess = false) => ({
    type : childActionTypes.formData,
    payload: { editMode, disableInputs, saveSuccess }
});

export const setLangs = data => ({
    type : childActionTypes.langs,
    payload : data
});

export const setFilter = data => ({
    type: childActionTypes.filter,
    payload: data
});

export const setTableParams = ( pageSize= 10, pageIndex= 0, totalSize= 0) => ({
    type : childActionTypes.tableParams,
    payload: { pageSize, pageIndex, totalSize }
});

export const setItems = data => ({
    type: childActionTypes.listDomainObjects,
    payload: data
});

export const setModal = data => ({
    type: childActionTypes.showModal,
    payload: data
});

export const setSubLoading = data => ({
    type: childActionTypes.loading,
    payload: data
});

export const removeItem = data => ({
    type : childActionTypes.removeItem,
    payload: data
});

export const addItem = data => ({
    type : childActionTypes.addItem,
    payload: data
});

export const changeListItem = data => ({
    type : childActionTypes.changeItem,
    payload: data
});